import './styles.scss';

import React from 'react';

import { ReactComponent as AlertIcon } from '../../../assets/icons/alert-icon.svg';
import { ReactComponent as ErrorCheckmark } from '../../../assets/icons/error-checkmark.svg';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info-icon.svg';
import { ReactComponent as SuccessCheckmark } from '../../../assets/icons/success-checkmark.svg';
import { CARD_STATUS } from '../../constants/constants';
import { ICardStatusProps } from '../../interfaces/global';

const CardStatus = ({ message, type }: ICardStatusProps) => {
  const loadImage = () => {
    if (type === CARD_STATUS.success) {
      return <SuccessCheckmark />;
    }
    if (type === CARD_STATUS.error) {
      return <ErrorCheckmark />;
    }
    if (type === CARD_STATUS.informative) {
      return <InfoIcon />;
    }
    if (type === CARD_STATUS.alert) {
      return <AlertIcon />;
    }
  };

  return (
    <div className={`status-card-container ${type}`}>
      <div className="status-card-icons">{loadImage()}</div>
      <div className="status-card-text">{message}</div>
    </div>
  );
};

export default CardStatus;
